<template>
    <p class="text-danger">
        <slot></slot>
    </p>
</template>